import TranslatableRichTextField from './TranslatableRichTextField';

export default TranslatableRichTextField;
